import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpRequestConstants } from '../../shared/http-request-constants';
import { IClaimService } from './iclaim.service';
import { environment } from '../../environments/environment';
import { ClaimRequest } from './claim-request';
import { ReimbursementRequest } from '../reimbursement/reimbursement-request';

@Injectable({
  providedIn: 'root'
})
export class ClaimService implements IClaimService {

  public baseContractManagementUrl = environment.baseClaimSubmissionUrl;
  public httpClient: HttpClient;

  constructor(http: HttpClient) {
    this.httpClient = http;
  }
  
  public getVehicleMakesAndModels(year: number): Observable<any[]> {
    const url = `${this.baseContractManagementUrl}/claim-submission/vehicles/${year}`;
    return this.httpClient.get(url, HttpRequestConstants.getHttpOptionsForRequest())
      .pipe(
        map(response => {
          return response as any[];
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public saveClaim(estimateFile: File, pictureFiles: File[], claim: ClaimRequest): Observable<boolean> {
    
    const formData = new FormData();
    const url: string = `${this.baseContractManagementUrl}/claim-submission/repair-facility`;

    formData.append("estimateFile", estimateFile);

    pictureFiles.forEach(importFile => {
      formData.append("pictureFiles", importFile);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'reportProgress': 'true',
        'observe': 'events',
        'timeout': '90000',
        'claimRequest': JSON.stringify(claim),
      }),
    }

    return this.httpClient.post(url, formData, httpOptions)
      .pipe(
        map(response => {
          return true;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  public saveReimbursementClaim(invoiceFile: File[], claim: ReimbursementRequest): Observable<boolean> {
    
    const formData = new FormData();
    const url: string = `${this.baseContractManagementUrl}/claim-submission/reimbursement`;

    invoiceFile.forEach(importFile => {
      formData.append("reimbursementFiles", importFile);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'reportProgress': 'true',
        'observe': 'events',
        'timeout': '90000',
        'claimRequest': JSON.stringify(claim),
      }),
    }

    return this.httpClient.post(url, formData, httpOptions)
      .pipe(
        map(response => {
          return true;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

}
